import { configureStore } from '@reduxjs/toolkit';
import transactionReducer from './redux/transactionSlice'; 

const store = configureStore({
  reducer: {
    transaction: transactionReducer, /**Add the slice reducer*/
  },
});

export default store;
